import VuexPersistence from 'vuex-persist';
import { createStore } from 'vuex'

import national from './national';
import user from './user';
import matches from './matches';
import match from './match';
import settings from './settings';
import teamList from './team-list';
import incidents from './incidents';
import page from './page';

const vuexLocal = new VuexPersistence({
//   key: 'assemble-sports-user',
  storage: window.localStorage,
  modules: ['national', 'user', 'match', 'settings', 'page']
});

// ASWL-2002: Fixtures filters (selected competitions / round) are persisted to localStorage.
// They belong to the role that picked them, so drop them whenever the active role changes
// (role switch, logout, or a different user logging in on the same device).
const clearRoleScopedFilters = (store) => {
  store.watch(
    state => (state.user.activeRole && state.user.activeRole._id) || null,
    (newRoleId, oldRoleId) => {
      if (newRoleId === oldRoleId) return;
      store.commit('page/clear');
      store.commit('matches/clear');
    }
  );
};

export default createStore({
  modules: {
    national,
    user,
    matches,
    match,
    teamList,
    incidents,
    page,
    settings,
  },
  plugins: [vuexLocal.plugin, clearRoleScopedFilters]
})
